import type { ReactNode } from 'react'

type WorkflowStepProps = {
  icon: ReactNode
  index: number
  title: string
  description: string
}

const WorkflowStep = ({ icon, index, title, description }: WorkflowStepProps) => (
  <div className='step'>
    <div className='step-icon'>{icon}</div>
    <div className='step-text'>
      <b>
        {index}. {title}
      </b>{' '}
      {description}
    </div>
  </div>
)

export default WorkflowStep
